import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const SkillRequestForm = ({ onSubmit, isSubmitting }) => {
    const { t } = useTranslation();
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!title.trim() || !description.trim()) return;
        onSubmit({ title: title.trim(), description: description.trim() });
        setTitle("");
        setDescription("");
    };

    return (
        <form onSubmit={handleSubmit} className="bg-white border border-gray-200 rounded-xl p-4 space-y-3">
            <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder={t("skillsPage.requests.titlePlaceholder")}
                maxLength={100}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder={t("skillsPage.requests.descriptionPlaceholder")}
                maxLength={500}
                rows={3}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <div className="flex items-center justify-between">
                <span className="text-xs text-gray-400">
                    {description.length}/500
                </span>
                <button
                    type="submit"
                    disabled={!title.trim() || !description.trim() || isSubmitting}
                    className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                    {isSubmitting
                        ? t("common.loading")
                        : t("skillsPage.requests.submit")}
                </button>
            </div>
        </form>
    );
};

export default SkillRequestForm;
